module.exports = __webpack_public_path__ + "images/dogTwo.4d829667.svg";